module.exports = __webpack_public_path__ + "static/media/logo.3d45a7cd.svg";